import React from "react";
import { NavLink } from "react-router-dom";
import MyIcon from "./MyIcon";
import styled from "styled-components";
import HelpButton from "../HelpContent/HelpButton";

export interface PageNavLinkProps {
  Icon: any;
  label: string | React.JSX.Element;
  href: string;
  badge?: string;
  className?: string;
  newFeature?: boolean;
}

function PageNavLinkComponent({
  Icon,
  label,
  href,
  badge,
  className,
}: PageNavLinkProps) {
  return (
    <NavLink
      to={href}
      className={(p) => `${p.isActive ? "active" : ""} p-3 py-0 ${className}`}
      draggable={false}
    >
      {Icon && (
        <div className="position-relative">
          <MyIcon Icon={Icon} width={40} />
          <span className="badge bg-dark-purple rounded-pill position-absolute top-0 end-0">
            {badge}
          </span>
          <span
            className="position-absolute start-50 top-0"
            style={{ marginLeft: -40 }}
            onClick={(e) => e.stopPropagation()}
          >
            <HelpButton
              helpKey={href
                .toString()
                .toLowerCase()
                .replace("/", "")
                .replace(/\s+|\//g, "-")}
            />
          </span>
        </div>
      )}

      <span className="mt-2 text-uppercase text-nowrap small fw-bold position-relative">
        {label}
      </span>
      <div
        className="bottom-border"
        style={{
          height: "5px",
          background: "var(--brand-gradient)",
          borderRadius: "5px",
        }}
      ></div>
    </NavLink>
  );
}

const PageNavLink = styled(PageNavLinkComponent)`
  display: block;
  text-align: center;
  opacity: 0.7;
  transition: opacity 0.3s;
  text-decoration: none;
  color: black;
  // height: 95px;

  .bottom-border {
    opacity: 0;
    transition: opacity 0.3s;
  }
  &:hover .bottom-border,
  &.active .bottom-border {
    opacity: 1;
  }
`;

export default PageNavLink;
